module.exports = __webpack_public_path__ + "img/tiger-face.858737a5.png";